import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-sanity@12.2.2_@emotion+is-prop-valid@1.4.0_@sanity+client@7.20.0_@sanity+types@5.2_323f6b8bd056e81b8f2235275c7c8618/node_modules/next-sanity/dist/live/client-components/live-stream/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-sanity@12.2.2_@emotion+is-prop-valid@1.4.0_@sanity+client@7.20.0_@sanity+types@5.2_323f6b8bd056e81b8f2235275c7c8618/node_modules/next-sanity/dist/live/client-components/live/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.3_@babel+core@7.29.0_@playwright+test@1.59.1_babel-plugin-react-compiler@1.0._a3b780249b0a08ef34a193e8333a8b41/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.3_@babel+core@7.29.0_@playwright+test@1.59.1_babel-plugin-react-compiler@1.0._a3b780249b0a08ef34a193e8333a8b41/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CtaBandForm"] */ "/vercel/path0/src/components/forms/CtaBandForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientsTrustUsMobileSlider"] */ "/vercel/path0/src/components/sections/ClientsTrustUsMobileSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Collaboration","BenefitsGuarantees","ServiceFaq","ServiceTestimonials","ContactForm","Portfolio","Team","Testimonials","Blog","FAQ","DetailedBriefForm","QuickAnswers","ServiceAudience"] */ "/vercel/path0/src/components/sections/LazySections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceConsultationForm"] */ "/vercel/path0/src/components/sections/ServiceConsultationForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/ServicesCatalogMiniForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamOrbitTrack"] */ "/vercel/path0/src/components/sections/TeamOrbitTrack.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/shared/Marquee.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/shared/PlayReelBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReelLightbox"] */ "/vercel/path0/src/components/shared/ReelLightbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReelPlayer"] */ "/vercel/path0/src/components/shared/ReelPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReelTeaser"] */ "/vercel/path0/src/components/shared/ReelTeaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReelThumbButton"] */ "/vercel/path0/src/components/shared/ReelThumbButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/shared/SectionDivider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CircleCTAButton"] */ "/vercel/path0/src/components/ui/CircleCTAButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/lib/image-loader.ts");
